module.exports = __webpack_public_path__ + "media/application/images/icons/arrow-right-4bfdc463ae9c214f863dc0fc34a81a77.svg";